import { ModalFooterType } from './modal.types'
import { cancelButtonLight, continueButtonWarn, confirmButton } from '../../components/buttons/button-styles'

export const defaultModalState = {
  id: null,
  type: null,
  display: false,
  handles: {},
  dispatches: {},
  kwargs: {},
}
